import { useMemo } from 'react';

import PageContainer from 'components/v2/container/PageContainer';
import Tabs from 'components/v2/tabs/Tabs';
import { useLocalization } from 'localization';
import { useAuth } from '../../../auth/hooks';
import { tabParams } from 'constants/ui/routes';
import MyAccount from '../myaccount/MyAccount';
import Overlay from 'components/v2/overlay/Overlay';
import UserAdministration from '../useradministration/UserAdministration';
import HelpCenter from '../helpcenter/HelpCenter';
import { isUserAdmin } from 'helpers/isUserAdmin';
import BranchSettings from 'modules/v2/branch/BranchSettings';

const AccountSettings = () => {
  const { t } = useLocalization();
  const { user, userIsLoading, userIsFetched } = useAuth();

  const allTabs = useMemo(
    () => [
      {
        key: tabParams.accountSettings.branch,
        label: t('accountSetting.branchSettings'),
        children: <BranchSettings />,
      },
      {
        key: tabParams.accountSettings.myAccount,
        label: t('accountSetting.myAccount'),
        children: <MyAccount />,
      },
      {
        key: tabParams.accountSettings.userAdministration,
        label: t('navigation.pageTitles.userAdministration'),
        children: <UserAdministration />,
      },
      {
        key: tabParams.accountSettings.helpCenter,
        label: t('navigation.mainMenu.helpCenter'),
        children: <HelpCenter />,
      },
    ],
    [t]
  );

  const visibleTabs = useMemo(() => {
    if (!userIsFetched) return [];

    const isAdmin = isUserAdmin(user);

    return allTabs.filter(tab => {
      if (tab.key === tabParams.accountSettings.userAdministration) {
        return isAdmin;
      }
      return true;
    });
  }, [allTabs, user, userIsFetched]);

  return (
    <PageContainer pageTitle="navigation.secondaryMenu.accountSetting">
      {userIsLoading ? <Overlay /> : <Tabs tabItems={visibleTabs} />}
    </PageContainer>
  );
};

export default AccountSettings;
